"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var errorHandler_1 = require("../../common/service/errorHandler");
var usePlatformConfig_1 = require("../../common/react/usePlatformConfig");
var PaymentProviders_1 = require("../../common/enum/PaymentProviders");
var errorMessageHoc_1 = require("../../common/components/presentation/Error/errorMessageHoc");
var PaymentVisaNet_1 = require("./paymentProviders/visanet/PaymentVisaNet");
var ApexxPaymentForm_1 = require("./paymentProviders/apexx/ApexxPaymentForm");
var Payment = function () {
    var parentNodeId = react_1.useState('wrapper:checkout:paymentProvider')[0];
    var paymentProvider = usePlatformConfig_1.default().platformConfig.paymentProvider;
    if (PaymentProviders_1.PaymentProviders.VISA_NET === paymentProvider) {
        return <PaymentVisaNet_1.default />;
    }
    if (PaymentProviders_1.PaymentProviders.APEXX === paymentProvider) {
        return <ApexxPaymentForm_1.default />;
    }
    errorHandler_1.default.handleError("No payment provider was selected. [" + parentNodeId + "]");
    return <div data-test="payment_page:no_payment_provider">There is no payment provider</div>;
};
exports.default = errorMessageHoc_1.default(Payment);
